import { Pipe, PipeTransform } from '@angular/core';
import { TimeSlot } from '@thehubz/client/core';
import { WEEK_DAYS } from '../constants/week-days';
import { DayAvailability } from '../models';

/**
 * Pipe to get all time slots from the form group
 */
@Pipe({
  name: 'getTimeSlots',
  pure: false,
})
export class GetTimeSlotsPipe implements PipeTransform {
  transform(dailyAvailability: Record<string, DayAvailability>): TimeSlot[] {
    if (!dailyAvailability) {
      return [];
    }
    const timeSlots: TimeSlot[] = [];

    WEEK_DAYS.forEach((day) => {
      const dayAvailability = dailyAvailability[day.key];
      if (dayAvailability.selected) {
        timeSlots.push(...(dayAvailability.timeSlots || []));
      }
    });

    return timeSlots;
  }
}
